export default "__VITE_ASSET__BqY6pWOd__"